import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/artshowitem";

export default createStore({ Model });
